import React from "react";
import { faSignInAlt, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { useRouter } from "next/navigation";

import Button from "@/components/button";
import { ButtonBar, Module } from "@/components/layouts/";
import { ButtonGroup } from "@/components/layouts/button-group";
import { useModal } from "@/hooks/use-modal";

import ModalTitle from "./modal-title";

const NotSignedInModal = () => {
  const router = useRouter();
  const { closeModal } = useModal();

  const onCancelClicked = () => {
    closeModal();
  };

  const onSignInClicked = () => {
    closeModal();
    router.push("/sign-in");
  };

  return (
    <div className="text-center">
      <ModalTitle>Not signed in</ModalTitle>
      <Module>
        <p>Sorry, you need to sign in to do that.</p>
      </Module>
      <ButtonBar>
        <ButtonGroup align="right">
          <Button
            icon={faTimesCircle}
            onClick={onCancelClicked}
            type="negative"
          >
            Cancel
          </Button>
          <Button
            icon={faSignInAlt}
            onClick={onSignInClicked}
            type="positive"
          >
            Sign In
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
};

export default NotSignedInModal;
